import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onUntrapLpcFocus = action('onUntrapLpcFocus', event => ({
    event,
    owaType: 'untrapLpcFocus',
})) as OwaNovaActionUnion<'untrapLpcFocus'>;
